/** Текст для красного бейджа в меню; null — не показывать. */
export function formatInactiveOrderReminderPendingBadge(count: number | null | undefined): string | null {
    if (count == null || count <= 0) {
        return null;
    }
    if (count > 100) {
        return "99+";
    }
    return String(count);
}
